export default __webpack_public_path__ + "static/media/Apple Thunderbolt Display 27.421bb1b9.png";